import World from './World'
import Scene from './Scene'
import Mouse from './Mouse'
import UI from './UI'

import Level from './Level'
import Player from './Player'

/**
 * Game class
 *      - responsible for the main update loop, timekeeping and creating other management classes
 */
export default class {
    constructor (selector) {
        let element = document.querySelector(selector)
        if (element.tagName !== 'CANVAS') {
            throw Error('Invalid selector')
        }
        this._currentTime = 0
        this._tickLength = 10
        this._timer = null
        this._tickTimeouts = []
        this._tickCallbacks = []

        this._scene = new Scene(element)
        this._mouse = new Mouse(element)
        this._ui = new UI(this)
        this._world = new World(this)
    }

    start () {
        this._player = new Player(this, this._scene.getCenter(), 'red')
        this._level = new Level(this)
        this._startTimer()
        return this
    }

    pause () {
        if (this._timer) {
            clearInterval(this._timer)
            this._timer = false
        }
        return this
    }

    unPause () {
        return this._startTimer()
    }

    getCurrentTime () {
        return this._currentTime
    }

    getWorld () {
        return this._world
    }

    getScene () {
        return this._scene
    }

    getMouse () {
        return this._mouse
    }

    getPlayer () {
        return this._player
    }

    setTickTimeout (callback, ticks) {
        let targetTick = this._currentTime + ticks
        if (!this._tickTimeouts[ targetTick ]) this._tickTimeouts[ targetTick ] = []
        this._tickTimeouts[ targetTick ].push(callback)
    }

    onTick (callback) {
        this._tickCallbacks.push(callback)
    }

    _tick () {
        try {
            this._currentTime++
            this._scene.clear()
            this._world.update(this._currentTime)
            this._handleTickCallbacks()
            this._handleTickTimeouts()
            return this
        } catch (error) {
            console.error(error)
            this.pause()
        }
    }

    _handleTickCallbacks () {
        this._tickCallbacks.forEach(tickCallback => {
            tickCallback(this._currentTime)
        })
    }

    _handleTickTimeouts () {
        if (this._tickTimeouts[ this._currentTime ]) {
            this._tickTimeouts[ this._currentTime ].forEach(timeoutCallback => {
                timeoutCallback(this._currentTime)
            })
            delete this._tickTimeouts[ this._currentTime ]
        }
    }

    _startTimer () {
        if (!this._timer) {
            this._timer = setInterval(() => this._tick(), this._tickLength)
        }
        return this
    }
}
